import React from 'react'
import ReactDOM from "react-dom"
import BasicButton, {CancelButton, ConfirmButton} from "./BasicButton";
import {setHelpContext} from "../prodect/HelpManager";

export default function BasicModal(title, passedContent, params) {
    const content = passedContent

    let param = params || {}
    let textContent = content ? <section
        onMouseDown={(evt)=>  onMouseDown(evt)}
        className={param.contentClassName}
    >{content === 'string' ? <p>{content}</p> : content}</section> : null
    let dismissButton = param.hideDismissButton ? null : <CancelButton
        action={()=> {
            if(typeof param.cancelCallback === 'function') param.cancelCallback()
            BasicModalDismiss()
        }}
    />
    let hasCustomAction = typeof param.action === 'function'
    let actionButton = hasCustomAction ? <ConfirmButton
            label={param.btnText || "OK"}
            icon={param.btnIcon}
            action={() => {
                param.action()
                BasicModalDismiss()
                if(typeof param.callback === 'function') param.callback()
            }}
            btnType={param.btnType}
        />
        : null


    function onMouseDown(evt){
        evt.stopPropagation()
    }

    //update html DOM
    BasicModalHtml(<>
        <div id={"BasicModalOverlay"}/>
        <div className={"modal-window"}
             onMouseDown={(evt) => {
                 onMouseDown(evt)
                 BasicModalDismiss()
             }}
        >
            <div id="BasicModalContent"
                onMouseDown={evt=> onMouseDown(evt)}//has to be
                className={param.className || null}
            >
                <header>
                    <h2>{title}</h2>
                    <BasicButton
                        icon={"times"}
                        action={()=> BasicModalDismiss()}
                    />
                </header>
                {textContent}
                {param.customButtons || dismissButton || actionButton ?
                <footer>
                    <div className={"btn-set"}>{param.customButtons}{dismissButton}{actionButton}</div>
                </footer> : null}
            </div>
        </div>
    </>, param.keepWidth)
}

export function BasicModalDismiss() {
    ExitModal(document.getElementById("BasicModal"), ()=> BasicModalHtml(null))
}

function BasicModalHtml(html, keepWidth) {
    ReactDOM.render(
        html,
        document.getElementById("BasicModal"),
        ()=> {
            if(keepWidth) setModalSize()
        }
    )
}

export function ExitModal(element, _callback) {
    setHelpContext('closePopup')
    if(element == null) {
        _callback()
        return
    }
    element.classList.add("exit-modal")
    setTimeout(()=>{
        element.classList.remove("exit-modal")
        _callback()
    }, 95)//less than in CSS
}

export function setModalSize(){
    let el = document.getElementById("BasicModalContent")
    //keepWidth for keeping initial size to reduce jumping
    if(el){
        const width = el.offsetWidth + 'px'
        el.style.width = width
    }
}